module.exports = __webpack_public_path__ + "static/media/surprised-emoji-svgrepo-com (2).0e3414aa.svg";